import React, { useEffect, useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Navbar from './navbar';
import Sidebar from './slidebar';
import { Box, CircularProgress, useMediaQuery } from '@mui/material';
import { useTheme } from '@emotion/react';
import useNetworkStatus from '../../provider/networkStatus';
import NetworkIssuePopup from '../popups/networkIssuePopup';
import { useCompany } from '../../provider/companyProvider';

function Layout() {
    const theme = useTheme();
    const isTablet = useMediaQuery(theme.breakpoints.down('md'));
    const { isOnline } = useNetworkStatus();
    const location = useLocation();

    const [selectedBranch, setSelectedBranch] = useState(null);

    useEffect(() => {
        setSelectedBranch(null);
    }, [location.pathname]);

    const { loading } = useCompany();

    return (
        <Box>
            <Sidebar />
            <Box
                sx={{
                    position: 'fixed',
                    display: 'flex',
                    top: 0,
                    zIndex: 1100,
                    width: '100%'
                }}>
                <Box sx={{
                    width: isTablet ? '60px' : '240px',
                }}> </Box>
                <Box sx={{ width: isTablet ? 'calc(100% - 60px)' : 'calc(100% - 240px)', }}>
                    <Navbar selectedBranch={selectedBranch} setSelectedBranch={setSelectedBranch} />
                </Box>

            </Box>
            {
                !isOnline &&
                <NetworkIssuePopup />
            }
            <Box height={50}></Box>
            <Box sx={{
                display: 'flex',
                width: '100%'
            }}>
                <Box sx={{
                    width: isTablet ? '60px' : '240px',
                }}> </Box>

                {
                    loading ?
                        <Box
                            display="flex"
                            flexDirection="column"
                            alignItems="center"
                            justifyContent="center"
                            height="100vh"
                            width='100%'
                        >
                            <CircularProgress color="primary" />
                        </Box>
                        :
                        <Box sx={{ width: isTablet ? 'calc(100% - 60px)' : 'calc(100% - 240px)', }}>
                            <Outlet context={{ selectedBranch }} />
                        </Box>
                }

            </Box>

        </Box>
    );
}

export default Layout;
